import { createFileRoute, Navigate } from "@tanstack/react-router";
import { RequireSignedIn } from "@/components/auth/RequireSignedIn";
import { RequireOrganization } from "@/components/organization/RequireOrganization";
import { ROUTES } from "@/constants/routeConstants";

function IndexComponent() {
  return (
    <RequireSignedIn>
      <RequireOrganization>
        <Navigate to={ROUTES.ANALYTICS} replace={true} />
      </RequireOrganization>
    </RequireSignedIn>
  );
}

export const Route = createFileRoute("/")({
  component: IndexComponent,
});
